module.exports = __webpack_public_path__ + "img/slogan.b13f711f.png";